export enum FundAccountPeriod {
    LAST_QUARTER = 'LAST_QUARTER',
    LAST_SEMESTER = 'LAST_SEMESTER',
    LAST_FIVE_MONTHS = 'LAST_FIVE_MONTHS',
    LAST_FIVE_YEARS = 'LAST_FIVE_YEARS',
    LAST_YEAR = 'LAST_YEAR'
}
